var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraEmpty = function SvgCameraEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.25 15.52"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "camera-empty_svg__cls-1",
    d: "M22.7 2.04a1 1 0 0 0-1 .08l-5.18 3.7V2.93A2.93 2.93 0 0 0 13.59 0H2.93A2.93 2.93 0 0 0 0 2.93v9.66a2.93 2.93 0 0 0 2.93 2.93h10.62a2.93 2.93 0 0 0 2.93-2.93V9.7l5.14 3.7a1 1 0 0 0 .58.19 1 1 0 0 0 .46-.11 1 1 0 0 0 .54-.89V2.93a1 1 0 0 0-.5-.89Zm-8.22 10.55a.93.93 0 0 1-.93.93H2.93a.93.93 0 0 1-.93-.93V2.93A.93.93 0 0 1 2.93 2h10.62a.93.93 0 0 1 .93.93Zm6.76-1.94-4-2.89 4-2.89Z"
  })));
};
export default SvgCameraEmpty;